// extracted by mini-css-extract-plugin
export default {"inputBox":"inputToken_inputBox__Yxy4v","container":"inputToken_container__jLdNf"};